import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import PortalTermsAndConditionsVM from './PortalTermsAndConditionsVM';
import { observer } from 'mobx-react';
import { DangerousHtmlEditor } from "@singularsystems/neo-notifications";
import { ModalUtils } from "@singularsystems/neo-core";

class PortalTermsAndConditionsParams {
    // TODO: Add parameters here in the form: public paramName = { isQuery?: boolean, required?: boolean };
}

@observer
export default class PortalTermsAndConditionsView extends Views.ViewBase<PortalTermsAndConditionsVM, PortalTermsAndConditionsParams> {
   public static params = new PortalTermsAndConditionsParams();

    constructor(props: unknown) {
        super("Portal Terms And Conditions", PortalTermsAndConditionsVM, props);
    }

    protected viewParamsUpdated() {

    }

    public render() {
        const viewModel = this.viewModel;

        return (
            <Neo.Card title="Portal Terms And Conditions">
			    
                <div className="text-end mb-3">
                    <Neo.Button onClick={() => this.beginSaveTermsAndConditions()} icon="save" variant="primary">Save</Neo.Button>
                </div>

                {viewModel.htmlEditorController &&
                    <DangerousHtmlEditor htmlEditorOptions={viewModel.htmlEditorController} />}

            </Neo.Card>
        );
    }

    private beginSaveTermsAndConditions() {
        if (this.viewModel.termsAndConditions) {
            if (this.viewModel.termsAndConditions.portalTermsAndConditionsId) {
                ModalUtils.showModal("Save Terms And Conditions", 
                    "Do users who have accepted these terms and conditions need to re-accept after these changes?",
                    { 
                        buttons: [
                            { text: "Yes, fundamental changes", variant: "secondary", onClick: () => this.viewModel.saveTermsAndConditions(true) },
                            { text: "No, only minor changes", variant: "secondary", onClick: () => this.viewModel.saveTermsAndConditions(false) }
                        ]
                    });
            } else {
                this.viewModel.saveTermsAndConditions(true)
            }
        }
    }
}